import { render, staticRenderFns } from "./brainCardiovascularInfoItemTd.vue?vue&type=template&id=6d41d7f8"
import script from "./brainCardiovascularInfoItemTd.vue?vue&type=script&lang=js"
export * from "./brainCardiovascularInfoItemTd.vue?vue&type=script&lang=js"
import style0 from "./brainCardiovascularInfoItemTd.vue?vue&type=style&index=0&id=6d41d7f8&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d41d7f8')) {
      api.createRecord('6d41d7f8', component.options)
    } else {
      api.reload('6d41d7f8', component.options)
    }
    module.hot.accept("./brainCardiovascularInfoItemTd.vue?vue&type=template&id=6d41d7f8", function () {
      api.rerender('6d41d7f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/bcs/brainCardiovascularInfoItemTd.vue"
export default component.exports